import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/layout/header/header.component';
import { SidebarComponent } from './shared/components/layout/sidebar/sidebar.component';
import { FooterComponent } from './shared/components/layout/footer/footer.component';

import { LayoutComponent } from './shared/components/layout/layout.component';
import { HttpClientModule } from '@angular/common/http';
import { InterceptorModule } from './shared/interceptors/http-interceptor.module';
import { UsuarioService } from './shared/services/usuario.service';
import { SharedModule } from "./shared/shared.module";
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LOCALE_ID, isDevMode, APP_INITIALIZER } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { CriarSenhaLoginComponent } from './modules/usuario/authentication/criar-senha-login/criar-senha-login.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { PwaManagerService } from './shared/services/pwa-manager.service';

registerLocaleData(localePt, 'pt');

// Função para inicializar PWA
export function initializePwa(pwaManager: PwaManagerService) {
  return () => {
    // O serviço já inicializa automaticamente no constructor
    return Promise.resolve();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    LayoutComponent,
    CriarSenhaLoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    InterceptorModule,
    SharedModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
],
  providers: [
    UsuarioService, 
    { provide: LOCALE_ID, useValue: 'pt' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializePwa,
      deps: [PwaManagerService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
